module.exports = __webpack_public_path__ + "static/media/plates.28bfd1f0.jpg";